var map = {
	"./Blue Matter.png": 5088,
	"./Cobham.png": 5974,
	"./Edata Services.png": 6883,
	"./Epinion.png": 960,
	"./GaleSun Tech.png": 3560,
	"./Gates Foundation.png": 1157,
	"./H&Z.svg": 2113,
	"./KPMG.png": 8802,
	"./KPS.png": 4582,
	"./LionBridge.png": 5516,
	"./Paramount.png": 8907,
	"./Siemens.svg": 5276,
	"./Trace3.webp": 8818,
	"./Universal.png": 4868,
	"./Valcon.svg": 9409
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4631;